import React from 'react';

import { addThousandSeparator } from '../../../helpers/format';

class TextView extends React.PureComponent {
  renderItems() {
    const data = this.props.data;
    return data.map((item, index) => {
      return (
        <div key={ index }>
          <div className="statistics-text-view__head">
            { item.question }
          </div>
          <div className="statistics-text-view__number">
            { addThousandSeparator(item.total) }
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="statistics-text-view">
        { this.renderItems() }
      </div>
    );
  }
}

export default TextView;



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/TextView.js